import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { getConsent, loadGtag, trackPageView } from '@/lib/analytics';

/**
 * Sends a page view on every route change. A single-page app never reloads, so
 * without this Google would only ever see the first page of a visit.
 *
 * Keyed on the path alone: a query string can hold an email address or a
 * token, and a change to it alone is not a new page.
 */
export function AnalyticsTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    // A returning visitor who accepted before: load on the first page.
    if (getConsent() === 'granted') loadGtag();
    trackPageView(pathname);
  }, [pathname]);

  return null;
}
